export default {
  variants: [],
  variant: {},
};
